<template>
<div class="AddRuleOverlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
        <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
          <div class="row margin-left-1Point6Perc">
            <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                  {{getCurrentlySelectedCourseObj.CourseTitle}}
            </div>
            <div class="col-md-5 col-lg-5">
              <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeAddRuleOverlay($event,false)">
                <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
              </div>
            </div>
          </div>
          <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
              <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                  {{lessonObj.Title}}
              </div>
          </div>

          <div class="row vertical-align margin-bottom-5Perc margin-top-5Perc" v-if="!showAddRuleUI && !showViewRuleActionListUI">
            <div class="col-md-1 col-lg-1"></div>
            <div class="col-md-8 col-lg-8 padding-left-0px padding-right-0px margin-0-auto font-size-16px font-weight-bold">Rule + Action Set-up for <span class="text-color-orange"><i><u>{{ElementObj.Title}}</u></i></span> element.</div>
            <div class="col-md-1 col-lg-1"></div>
          </div>

          <div class="row vertical-align margin-bottom-5Perc margin-top-5Perc" v-if="!showAddRuleUI && !showViewRuleActionListUI">
            <div class="col-md-2 col-lg-2"></div>
            <div class="col-md-4 col-lg-4">
              <div class="row vertical-align">
                <div class="col-md-12 col-lg-12 cursor-pointer">
                  <span class="glyphicon glyphicon-plus font-size-100px opacity-point-9" @click="performAction('AddRuleAction')"></span>
                </div>
              </div>
              <div class="row vertical-align margin-top-3Perc">
                <div class="col-md-12 col-lg-12 font-size-17px font-weight-bold font-color-blue cursor-pointer" @click="performAction('AddRuleAction')">
                  Add New
                </div>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="row vertical-align">
                <div class="col-md-12 col-lg-12">
                  <span class="glyphicon glyphicon-list-alt cursor-pointer font-size-100px font-weight-bold padding-top-3-Perc font-color-blue opacity-point-9" @click="performAction('ViewRuleAction')"></span>
                </div>
              </div>
              <div class="row vertical-align margin-top-3Perc">
                <div class="col-md-12 col-lg-12 font-size-17px font-weight-bold font-color-blue cursor-pointer" @click="performAction('ViewRuleAction')">
                  View Existing List
                </div>
              </div>
            </div>
            <div class="col-md-2 col-lg-2"></div>
          </div>

        <div class="row vertical-align margin-bottom-2Perc" v-if="showAddRuleUI || showViewRuleActionListUI">
          <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
            <span @click="performAction('BackToMenu')" class="text-color-orange cursor-pointer"> <u>< Back to Menu</u></span>
          </div>
          <div class="create-lesson-input-text-style col-md-5 col-lg-5 text-align-left padding-right-0Perc">

          </div>
          <div class="create-lesson-input-text-style col-md-5 col-lg-5 padding-right-0Perc text-align-left">
          </div>
        </div>

        <div v-if="showViewRuleActionListUI">

          <editable-rule-action-list v-for="(editableRAObj, index) in editableRuleActionList" :key="editableRAObj.ElementRuleActionId" :currEditableRuleActionIndex="index" v-bind:currEditableRuleActionObj="editableRAObj" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:elementRuleList="getRules" :actionList="getActions" :editableRuleActionList="getEditableRuleActionList" @updatedExistingRuleActionList="updateExistingRuleActionList" @selectedRuleActionObj="openEditPopUp"></editable-rule-action-list>

          <div class="row vertical-align margin-bottom-5Perc margin-top-5Perc" v-if="editableRuleActionList.length === 0">
            <div class="col-md-2 col-lg-2"></div>
            <div class="col-md-8 col-lg-8 font-size-21px text-color-blue">No rules and actions are setup for "{{this.ElementObj.Title}}" element.</div>
            <div class="col-md-2 col-lg-2"></div>
          </div>

          <div class="row margin-bottom-2Perc" v-if="editableRuleActionList.length === 0">
            <div class="col-md-5 col-lg-5"></div>
            <div class="col-md-2 col-lg-2">
              <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="performAction('BackToMenu')">Back</button>
            </div>
            <div class="col-md-5 col-lg-5"></div>
          </div>

          <div class="row margin-bottom-2Perc"></div>

          <div class="row vertical-align margin-bottom-2Perc" v-if="actionObjFromList !== null && selectedEditableRuleActionObj !== null && editableRuleActionList.length > 0">
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 padding-right-0Perc text-align-right">
            </div>
            <div class="col-md-10 col-lg-10 font-size-18px padding-left-15px border-1px-solid-grey padding-top-20px padding-bottom-20px background-color-light-grey">
              <div class="col-lg-12 col-md-12">
                <update-show-alert-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action3)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-show-alert-action>
                <update-send-notification-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action4)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-send-notification-action>
                <update-send-email-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action2)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-send-email-action>
                <update-remove-element-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action1)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-remove-element-action>
                <update-add-element-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action5)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-add-element-action>
                <update-add-recommendation-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action6)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-add-recommendation-action>
                <update-remove-recommendation-action v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedEditableRuleActionObj="selectedEditableRuleActionObj" :actionList="actionList" :actionObjFromList="actionObjFromList" v-if="(editableRuleActionList.length > 0 && actionObjFromList.ActionName === constants.PersonalizationAction.Action7)" @updatedExistingRuleActionList="updateExistingRuleActionList"></update-remove-recommendation-action>
              </div>
            </div>
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 padding-right-0Perc text-align-right">
            </div>
          </div>
        </div>

        <div v-if="showAddRuleUI">
          <div class="row vertical-align margin-bottom-2Perc">
            <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
              Rule
            </div>
            <div class="col-md-4 col-lg-4 padding-left-0px font-size-18px">
              <div class="col-lg-12 col-md-12">
                <select class="form-control" v-model="getSelectedRuleObj">
                  <option value=-1 disabled>Select</option>
                  <option v-for="ruleObj in getRules" v-bind:key="ruleObj.RuleMasterId" v-bind:value="ruleObj">
                    {{ ruleObj.RuleName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="col-sm-12"></div>
              </div>
            </div>
            <div class="col-md-1 col-lg-1"></div>
          </div>

          <div class="row vertical-align margin-bottom-2Perc">
            <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
            </div>
            <div class="col-md-9 col-lg-9 padding-left-0px font-size-18px">
              <div class="col-lg-12 col-md-12" v-if="showRuleUI">
                <min-max-range-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule1 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule7)"></min-max-range-rule-input>
                <specific-option-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule2 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule3)"></specific-option-rule-input>
                <option-in-range-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule4)"></option-in-range-rule-input>
                <correct-or-incorrect-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule5 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule6)"></correct-or-incorrect-rule-input>
                <is-completed-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule14)"></is-completed-rule-input>
                <path-is-exactly-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-bind:currentPath="currentPath" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule8)"></path-is-exactly-rule-input>
                <path-has-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-bind:currentPath="currentPath" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule9)"></path-has-rule-input>
                <specific-outcome-rule-input @selectedValues="updateRuleValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" v-if="selectedRuleObj !== null && (selectedRuleObj.RuleName === constants.PersonalizationRule.Rule10 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule11 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule12 || selectedRuleObj.RuleName === constants.PersonalizationRule.Rule13)"></specific-outcome-rule-input>
              </div>
              <div class="col-lg-12 col-md-12" v-else></div>
            </div>
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 padding-right-0Perc text-align-right">
            </div>
          </div>

          <hr width="90%" v-if="isRuleParamValuesPresent">

          <div class="row vertical-align margin-bottom-2Perc" v-if="isRuleParamValuesPresent">
            <div class="create-lesson-input-text-style col-md-2 col-lg-2 padding-right-0Perc text-align-right">
              Action
            </div>
            <div class="col-md-4 col-lg-4 padding-left-0px font-size-18px">
              <div class="col-lg-12 col-md-12">
                <select class="form-control" v-model="getSelectedActionRuleObj">
                  <option value=-1 disabled>Select</option>
                  <option v-for="actionObj in getActions" v-bind:key="actionObj.ActionMasterId" v-bind:value="actionObj">
                    {{ actionObj.ActionName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group">
                <div class="col-sm-12">
                </div>
              </div>
            </div>
            <div class="col-md-1 col-lg-1"></div>
          </div>

          <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedActionRuleObj !== -1 && isRuleParamValuesPresent">
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 padding-right-0Perc text-align-right">
            </div>
            <div class="col-md-10 col-lg-10 font-size-18px border-1px-solid-grey padding-top-20px padding-bottom-20px background-color-light-grey">
              <div class="col-lg-12 col-md-12">
                <send-email-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action2)"></send-email-action>
                <send-notification-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action4)"></send-notification-action>
                <show-alert-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action3)"></show-alert-action>
                <remove-element-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action1)"></remove-element-action>
                <add-element-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action5)"></add-element-action>
                <add-recommendation-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action6)"></add-recommendation-action>
                <remove-recommendation-action @selectedValues="updateRuleActionValues" v-bind:lessonObj="lessonObj" v-bind:ElementObj="ElementObj" v-bind:selectedRuleObj="selectedRuleObj" :selectedActionRuleObj="getSelectedActionRuleObj" v-if="getSelectedActionRuleObj !== null && (getSelectedActionRuleObj.ActionName === constants.PersonalizationAction.Action7)"></remove-recommendation-action>
              </div>
            </div>
            <div class="create-lesson-input-text-style col-md-1 col-lg-1 padding-right-0Perc text-align-right">
            </div>
          </div>

          <div class="row margin-bottom-2Perc">
            <div class="col-md-5 col-lg-5"></div>
            <div class="col-md-2 col-lg-2">
              <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" :disabled="!isRuleParamValuesPresent" @click="createRuleAction">Add Rule + Action</button>
            </div>
            <div class="col-md-5 col-lg-5"></div>
          </div>
        </div>

        <div class="row margin-bottom-2Perc" v-if="!showAddRuleUI && !showViewRuleActionListUI">
          <div class="col-md-5 col-lg-5"></div>
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeAddRuleOverlay($event,false)">Close</button>
          </div>
          <div class="col-md-5 col-lg-5"></div>
        </div>
        <div class="row"></div>
      </div>
    </div>
    </div>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixConfirmationString" v-bind:postfixString="postConfirmationString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performActionBasedOnInput"></confirmation-alert>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
 </div>

</template>

<script>
import { ruleActionService } from '@/server-util/rule-action-service'
import { constants } from '@/utils/constants'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
// import server from '@/utils/server'
// import forEach from 'lodash/forEach'
import MinMaxRangeRuleInput from '@/components/personalization_rule/MinMaxRangeRuleInput'
import SpecificOptionRuleInput from '@/components/personalization_rule/SpecificOptionRuleInput'
import AlertBox from '@/components/AlertOverlay'
import OptionInRangeRuleInput from './OptionInRangeRuleInput.vue'
import CorrectOrIncorrectRuleInput from './CorrectOrIncorrectRuleInput.vue'
import IsCompletedRuleInput from './IsCompletedRuleInput.vue'
import SendEmailAction from './SendEmailAction.vue'
import PathIsExactlyRuleInput from './PathIsExactlyRuleInput.vue'
import { elementService } from '@/server-util/element-service'
// import { courseService } from '@/server-util/course-service'
import PathHasRuleInput from './PathHasRuleInput.vue'
import SpecificOutcomeRuleInput from './SpecificOutcomeRuleInput.vue'
import SendNotificationAction from './SendNotificationAction.vue'
import AddElementAction from './AddElementAction.vue'
import AddRecommendationAction from './AddRecommendationAction.vue'
import RemoveRecommendationAction from './RemoveRecommendationAction.vue'
import ShowAlertAction from './ShowAlertAction.vue'
import RemoveElementAction from './RemoveElementAction.vue'
import EditableRuleActionList from './EditableRuleActionList.vue'
// import { dmAdminUtils } from '@/utils/dmAdminUtils'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import { isEmpty, isNull } from 'lodash'
import UpdateShowAlertAction from './UpdateShowAlertAction.vue'
import UpdateSendNotificationAction from './UpdateSendNotificationAction.vue'
import UpdateSendEmailAction from './UpdateSendEmailAction.vue'
import UpdateRemoveElementAction from './UpdateRemoveElementAction.vue'
import UpdateAddElementAction from './UpdateAddElementAction.vue'
import UpdateAddRecommendationAction from './UpdateAddRecommendationAction.vue'
import UpdateRemoveRecommendationAction from './UpdateRemoveRecommendationAction.vue'

export default {
  props: ['lessonObj', 'ElementObj'],
  created: function () {
    this.setDefaultValues()
    this.getRuleList()
  },
  data: function () {
    return {
      showAddRuleUI: false,
      showViewRuleActionListUI: false,
      showConfirmationBox: false,
      prefixConfirmationString: '',
      postConfirmationString: '',
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      selectedRule: null,
      selectedRuleObj: -1,
      selectedActionRuleObj: -1,
      elementRuleList: [],
      actionList: [],
      currentPath: [],
      editableRuleActionList: [],
      selectedEditableRuleActionObj: null,
      actionObjFromList: null,
      showRuleUI: false,
      finalObjToPost: {
        ElementId: '',
        RuleId: '',
        RuleParamValues: '',
        ActionId: '',
        ActionMetaData: {}
      }
    }
  },
  name: 'AddRuleOverlay',
  methods: {
    openEditPopUp (value) {
      this.selectedEditableRuleActionObj = null
      this.actionObjFromList = null
      setTimeout(() => {
        // console.log('1 this.selectedEditableRuleActionObj: ' + JSON.stringify(value))
        // console.log('2 this.editableObj: ' + JSON.stringify(value.editableObj))
        // console.log('3 this.actionObjFromList: ' + JSON.stringify(value.actionObjFromList))
        if (typeof value.editableObj.RuleParamValues !== 'string') {
          value.editableObj.RuleParamValues = JSON.parse(value.editableObj.RuleParamValues)
        }
        this.selectedEditableRuleActionObj = value.editableObj
        // console.log('4 this.selectedEditableRuleActionObj: ' + JSON.stringify(this.selectedEditableRuleActionObj))
        this.actionObjFromList = value.actionObjFromList
        // console.log('5 this.actionObjFromList: ' + JSON.stringify(this.actionObjFromList))
      }, 5)
    },
    updateExistingRuleActionList (value) {
      const operationName = value.OperationName
      const elementRuleActionId = value.ElementRuleActionId
      const foundIndex = findIndex(this.editableRuleActionList, (obj) => {
        return obj.ElementRuleActionId === elementRuleActionId
      })
      console.log('foundIndex: ' + foundIndex)
      if (foundIndex > -1) {
        switch (operationName) {
          case 'Delete':
            this.editableRuleActionList.splice(foundIndex, 1)
            this.selectedEditableRuleActionObj = null
            break
          case 'Edit':
            this.editableRuleActionList[foundIndex] = value.updatedObj
            this.showAlertDialog = true
            this.errorMsg = 'Input(s) updated successfully.'
            this.selectedEditableRuleActionObj = null
            this.actionObjFromList = null
            break
        }
      } else {
        console.log('Not Found personalization element for ' + operationName)
      }
    },
    performAction: function (selectedOperationName) {
      switch (selectedOperationName) {
        case 'BackToMenu':
          this.showAddRuleUI = false
          this.showViewRuleActionListUI = false
          this.selectedEditableRuleActionObj = null
          this.actionObjFromList = null
          break
        case 'ViewRuleAction':
          this.showAddRuleUI = false
          this.showViewRuleActionListUI = true
          break
        case 'AddRuleAction':
          this.showAddRuleUI = true
          this.showViewRuleActionListUI = false
          this.selectedRuleObj = -1
          this.selectedActionRuleObj = -1
          this.$store.state.personalizationElementListToPost = []
          break
      }
    },
    performActionBasedOnInput (value) {
      this.showConfirmationBox = false
      if (value) {
        this.getSelectedActionRuleObj = -1
      } else {
        this.$emit('closeShowRuleOverlay', false)
      }
    },
    createRuleAction: function () {
      var _this = this
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined &&
          storeObj.state.access_token !== '' &&
          storeObj.state.access_token !== null &&
          this.finalObjToPost !== undefined
        ) {
          this.$store.state.isLoading = true
          ruleActionService.createRuleAction(storeObj.state.access_token, _this.finalObjToPost).then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.$store.state.isLoading = false
                // AK: Used to hold the data of newly added Rule + Action list
                _this.editableRuleActionList.push(responseObj.data)
                _this.showConfirmationBox = true
                _this.prefixConfirmationString = 'Rule and it\'s associated Action successfully created. '
                _this.postConfirmationString = 'Do you want to add more?'
              } else {
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              this.$store.state.isLoading = false
              _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
        } else {
          console.log(
            'ACCESS TOKEN or POSTABLE OBJECT might is NULL hence declined CREATE RULE + ACTION OPERATION'
          )
        }
      }
    },
    updateRuleActionValues (value) {
      const actionType = value.ActionType
      this.finalObjToPost.ActionId = value.ActionMasterId
      console.log('actionType: ' + actionType)
      switch (actionType) {
        case constants.PersonalizationAction.Action1:
          let selectedElementList = value.ElementList
          var objToPush = {
            ElementList: selectedElementList
          }
          this.finalObjToPost.ActionMetaData = objToPush
          console.log('Action 1: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action2:
          let emailTemplatedId = value.EmailTemplateId
          let senderEmailId = value.SenderEmailId
          objToPush = {
            EmailTemplateId: emailTemplatedId,
            SenderEmailId: senderEmailId
          }
          this.finalObjToPost.ActionMetaData = objToPush
          console.log('Action 2: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action3:
          let alertTitle = value.Title
          let alertBody = value.Body
          let alertShowCustomPopUp = value.ShowCustomPopUp
          objToPush = {
            Title: alertTitle,
            Body: alertBody,
            ShowCustomPopUp: alertShowCustomPopUp
          }
          this.finalObjToPost.ActionMetaData = objToPush
          console.log('Action 3: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action4:
          alertTitle = value.Title
          alertBody = value.Body
          let moduleId = value.ModuleId
          let elementId = value.ElementId
          objToPush = {
            Title: value.Title,
            Body: value.Body,
            ModuleId: moduleId,
            ElementId: elementId
          }
          this.finalObjToPost.ActionMetaData = objToPush
          console.log('Action 4: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action5:
          let parentModuleId = value.ParentModuleId
          let parentElementId = value.ParentElementId
          let elementIds = value.ElementList
          objToPush = {
            ParentModuleId: parentModuleId,
            ParentElementId: parentElementId,
            ElementIds: elementIds
          }
          this.finalObjToPost.ActionMetaData = objToPush
          console.log('Action 5: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action6:
          this.finalObjToPost.ActionMetaData = value.objToPush
          console.log('Action 6: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationAction.Action7:
          this.finalObjToPost.ActionMetaData = value.objToPush
          console.log('Action 6: ' + JSON.stringify(this.finalObjToPost))
          break
      }
    },
    updateRuleValues (value) {
      this.selectedRule = value.Type
      this.finalObjToPost.RuleId = value.RuleId
      switch (this.selectedRule) {
        case constants.PersonalizationRule.Rule1:
          var objToPush = {
            MinScore: value.Min,
            MaxScore: value.Max
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 1: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule2:
        case constants.PersonalizationRule.Rule3:
          objToPush = {
            SelectedOption: value.SelectedOption,
            OptionId: value.OptionId
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 2/3: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule4:
          objToPush = {
            SelectedOption: value.SelectedOption,
            OptionId: value.OptionId
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 4: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule5:
        case constants.PersonalizationRule.Rule6:
          objToPush = {
            CorrectAnswer: value.CorrectAnswer,
            OptionId: value.OptionId
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 5/6: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule7:
          objToPush = {
            MinPercentage: value.Min,
            MaxPercentage: value.Max,
            TLQColor: value.TLQColor
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 7: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule8:
        case constants.PersonalizationRule.Rule9:
          objToPush = {
            Path: value.Path
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 8/9: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule10:
        case constants.PersonalizationRule.Rule11:
        case constants.PersonalizationRule.Rule12:
        case constants.PersonalizationRule.Rule13:
          objToPush = {
            Outcome: value.Outcome
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 10/11/12/13: ' + JSON.stringify(this.finalObjToPost))
          break
        case constants.PersonalizationRule.Rule14:
          objToPush = {
            UserProgress: value.UserProgress
          }
          this.finalObjToPost.RuleParamValues = objToPush
          console.log('Rule 14: ' + JSON.stringify(this.finalObjToPost))
          break
      }
      console.log('this.finalObjToPost: ' + JSON.stringify(this.finalObjToPost))
    },
    setDefaultValues: function () {
      this.finalObjToPost.ElementId = this.ElementObj.ElementId
      this.$store.state.personalizationElementListToPost = []
    },
    closeAddRuleOverlay: function (event, flagToUpdate) {
      this.$emit('closeShowRuleOverlay', flagToUpdate)
    },
    getRuleList: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
        this.$store.state.isLoading = true
        ruleActionService.getAllRules(storeObj.state.access_token, _this.ElementObj.ElementId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it in a local variable
              _this.elementRuleList = responseObj.data
              _this.getRuleActionList()
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET RULE LIST OPERATION'
        )
      }
    },
    getRuleActionList: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== '' ||
        storeObj.state.access_token !== null
      ) {
        ruleActionService.getAllAction(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              _this.actionList = responseObj.data
              _this.getExistingRuleActionList()
              if (parseInt(this.ElementObj.Type) === 11) {
                _this.getAdaptiveGamePathFromServer()
              } else {
                _this.$store.state.isLoading = false
              }
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET RULE ACTION LIST OPERATION'
        )
      }
    },
    getExistingRuleActionList: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        ruleActionService.getExistingRulesAndAction(storeObj.state.access_token, _this.ElementObj.ElementId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it in a local variable
              _this.editableRuleActionList = filter(responseObj.data, (obj) => {
                return obj.ElementId === this.ElementObj.ElementId
              })
            } else {
              // _this.showSpinner = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET EXISTING RULE AND IT\'S ASSOCIATED ACTION LIST OPERATION'
        )
      }
    },
    getAdaptiveGamePathFromServer: function () {
      var _this = this
      var storeObj = this.$store
      if (_this.ElementObj !== undefined && _this.ElementObj !== '' && _this.ElementObj !== null) {
        _this.$store.state.isLoading = true
        elementService
          .getAdaptiveGamePath(storeObj.state.access_token, _this.ElementObj.ElementId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.currentPath = responseObj.data
                _this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.showAlertDialog = true
              _this.$store.state.isLoading = false
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected Element Object is NULL hence declined GET ADAPTIVE GAME Paths'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    assignDefaultImage: function (event) {},
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getSelectedActionRuleObj !== -1 && this.getSelectedActionRuleObj !== undefined && this.getSelectedActionRuleObj !== null && this.getSelectedActionRuleObj !== 'null' && this.getSelectedActionRuleObj !== '') {
        const actionType = this.getSelectedActionRuleObj.ActionName
        let value = this.finalObjToPost.ActionMetaData
        console.log('Object During Validation: ', this.finalObjToPost)
        console.log('Value During Validation: ', value)
        if (typeof this.finalObjToPost.ActionMetaData === 'string') {
          try {
            value = JSON.parse(this.finalObjToPost.ActionMetaData)
          } catch (error) {
            console.error(error)
          }
        }
        console.log('actionType: ' + actionType)
        let valueToReturn = false

        switch (actionType) {
          case constants.PersonalizationAction.Action1:
            let selectedElementList = value.ElementList
            if (selectedElementList === undefined || selectedElementList === null || selectedElementList.length === 0) {
              this.showAlertDialog = true
              this.errorMsg = 'Please select atleast one step to remove.'
              valueToReturn = false
            } else {
              valueToReturn = true
            }
            break
          case constants.PersonalizationAction.Action2:
            let emailTemplatedId = value.EmailTemplateId
            let senderEmailId = value.SenderEmailId
            if (emailTemplatedId === undefined || emailTemplatedId === 'undefined' || emailTemplatedId === null || emailTemplatedId === 'null' || emailTemplatedId === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Please select a template.'
              valueToReturn = false
            } else if (senderEmailId === undefined || senderEmailId === 'undefined' || senderEmailId === null || senderEmailId === 'null' || senderEmailId === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Please select a sender.'
              valueToReturn = false
            } else {
              valueToReturn = true
            }
            break
          case constants.PersonalizationAction.Action3:
            let alertTitle = value.Title
            let alertBody = value.Body
            if (alertTitle === undefined || alertTitle === 'undefined' || alertTitle === null || alertTitle === 'null' || alertTitle === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Alert title can\'t be empty.'
              valueToReturn = false
            } else if (alertBody === undefined || alertBody === 'undefined' || alertBody === null || alertBody === 'null' || alertBody === '' || this.stripHtml(alertBody).length === 0) {
              this.showAlertDialog = true
              this.errorMsg = 'Alert body can\'t be empty.'
              valueToReturn = false
            } else {
              valueToReturn = true
            }
            break
          case constants.PersonalizationAction.Action4:
            alertTitle = value.Title
            alertBody = value.Body
            let moduleId = value.ModuleId
            let elementId = value.ElementId
            if (alertTitle === undefined || alertTitle === 'undefined' || alertTitle === null || alertTitle === 'null' || alertTitle === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Notification title can\'t be empty.'
              valueToReturn = false
            } else if (alertBody === undefined || alertBody === 'undefined' || alertBody === null || alertBody === 'null' || alertBody === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Notification body can\'t be empty.'
              valueToReturn = false
            } else if ((moduleId !== undefined && moduleId !== 'undefined' && moduleId !== null && moduleId !== 'null' && moduleId !== '') && (elementId === undefined || elementId === 'undefined' || elementId === null || elementId === 'null' || elementId === '')) {
              this.showAlertDialog = true
              this.errorMsg = 'Please select an element to open or else Reset lesson selection.'
              valueToReturn = false
            } else {
              valueToReturn = true
            }
            break
          case constants.PersonalizationAction.Action5:
            let parentModuleId = value.ParentModuleId
            let parentElementId = value.ParentElementId
            let elementIds = value.ElementIds
            // console.log(JSON.stringify(elementIds))
            if (parentModuleId === undefined || parentModuleId === 'undefined' || parentModuleId === null || parentModuleId === 'null' || parentModuleId === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Please select a lesson.'
              valueToReturn = false
            } else if (parentElementId === undefined || parentElementId === 'undefined' || parentElementId === null || parentElementId === 'null' || parentElementId === '') {
              this.showAlertDialog = true
              this.errorMsg = 'Please select any existing element below which you wish to attach new step(s).'
              valueToReturn = false
            } else if (elementIds === undefined || elementIds === null || elementIds.length === 0) {
              this.showAlertDialog = true
              this.errorMsg = 'Please select atleast one step to attach.'
              valueToReturn = false
            } else {
              valueToReturn = true
            }
            break
          case constants.PersonalizationAction.Action6:
            console.log('constants.PersonalizationAction.Action6:' + JSON.stringify(this.finalObjToPost.ActionMetaData))
            if (!isEmpty(this.finalObjToPost.ActionMetaData) && !isNull(this.finalObjToPost.ActionMetaData)) {
              valueToReturn = true
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Please select atleast one elective course from any group to add.'
              valueToReturn = false
            }
            break
          case constants.PersonalizationAction.Action7:
            console.log('constants.PersonalizationAction.Action7:' + JSON.stringify(this.finalObjToPost.ActionMetaData))
            if (!isEmpty(this.finalObjToPost.ActionMetaData) && !isNull(this.finalObjToPost.ActionMetaData)) {
              valueToReturn = true
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Please select atleast one elective course from any group to remove.'
              valueToReturn = false
            }
            break
        }
        return valueToReturn
      } else {
        this.errorMsg = 'Please select an action.'
        this.showAlertDialog = true
        return false
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of Confirmation Box overlay
      this.showConfirmationBox = value
      this.actionObjFromList = null
      this.selectedEditableRuleActionObj = null
      this.performAction('BackToMenu')
    }
  },
  components: {
    'alert-box': AlertBox,
    'min-max-range-rule-input': MinMaxRangeRuleInput,
    'specific-option-rule-input': SpecificOptionRuleInput,
    'option-in-range-rule-input': OptionInRangeRuleInput,
    'correct-or-incorrect-rule-input': CorrectOrIncorrectRuleInput,
    'is-completed-rule-input': IsCompletedRuleInput,
    'send-email-action': SendEmailAction,
    'send-notification-action': SendNotificationAction,
    'remove-element-action': RemoveElementAction,
    'add-element-action': AddElementAction,
    'add-recommendation-action': AddRecommendationAction,
    'remove-recommendation-action': RemoveRecommendationAction,
    'show-alert-action': ShowAlertAction,
    'path-is-exactly-rule-input': PathIsExactlyRuleInput,
    'path-has-rule-input': PathHasRuleInput,
    'specific-outcome-rule-input': SpecificOutcomeRuleInput,
    'confirmation-alert': ConfirmationOverlay,
    'editable-rule-action-list': EditableRuleActionList,
    'update-show-alert-action': UpdateShowAlertAction,
    'update-send-notification-action': UpdateSendNotificationAction,
    'update-send-email-action': UpdateSendEmailAction,
    'update-remove-element-action': UpdateRemoveElementAction,
    'update-add-element-action': UpdateAddElementAction,
    'update-add-recommendation-action': UpdateAddRecommendationAction,
    'update-remove-recommendation-action': UpdateRemoveRecommendationAction
  },
  computed: {
    getGroupList: {
      get: function () {
        // console.log('satish group list', this.$store.state.groupList)
        return this.$store.state.groupList
      },
      set: function (value) {
        this.$store.state.groupList = value
      }
    },
    isRuleParamValuesPresent: {
      get: function () {
        if (this.selectedRuleObj !== -1) {
          if (this.finalObjToPost.RuleParamValues !== undefined && this.finalObjToPost.RuleParamValues !== 'undefined' && this.finalObjToPost.RuleParamValues !== null && this.finalObjToPost.RuleParamValues !== 'null' && this.finalObjToPost.RuleParamValues !== '') {
            var isPresent = false
            switch (this.selectedRule) {
              case constants.PersonalizationRule.Rule1:
                if ((this.finalObjToPost.RuleParamValues.MinScore !== undefined && this.finalObjToPost.RuleParamValues.MinScore !== 'undefined' && this.finalObjToPost.RuleParamValues.MinScore !== null && this.finalObjToPost.RuleParamValues.MinScore !== 'null' && this.finalObjToPost.RuleParamValues.MinScore !== '') && (this.finalObjToPost.RuleParamValues.MaxScore !== undefined && this.finalObjToPost.RuleParamValues.MaxScore !== 'undefined' && this.finalObjToPost.RuleParamValues.MaxScore !== null && this.finalObjToPost.RuleParamValues.MaxScore !== 'null' && this.finalObjToPost.RuleParamValues.MaxScore !== '')) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
              case constants.PersonalizationRule.Rule2:
              case constants.PersonalizationRule.Rule3:
              case constants.PersonalizationRule.Rule4:
                if ((this.finalObjToPost.RuleParamValues.SelectedOption !== undefined && this.finalObjToPost.RuleParamValues.SelectedOption !== 'undefined' && this.finalObjToPost.RuleParamValues.SelectedOption !== null && this.finalObjToPost.RuleParamValues.SelectedOption !== 'null' && this.finalObjToPost.RuleParamValues.SelectedOption !== '')) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                console.log('isPresent: ' + isPresent + ' this.finalObjToPost.RuleParamValues.SelectedOption: ' + this.finalObjToPost.RuleParamValues.SelectedOption)
                break
              case constants.PersonalizationRule.Rule5:
              case constants.PersonalizationRule.Rule6:
                if ((this.finalObjToPost.RuleParamValues.CorrectAnswer !== undefined && this.finalObjToPost.RuleParamValues.CorrectAnswer !== 'undefined' && this.finalObjToPost.RuleParamValues.CorrectAnswer !== null && this.finalObjToPost.RuleParamValues.CorrectAnswer !== 'null' && this.finalObjToPost.RuleParamValues.CorrectAnswer !== '' && this.finalObjToPost.RuleParamValues.CorrectAnswer.trim().length !== 0)) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
              case constants.PersonalizationRule.Rule7:
                if ((this.finalObjToPost.RuleParamValues.MinPercentage !== undefined && this.finalObjToPost.RuleParamValues.MinPercentage !== 'undefined' && this.finalObjToPost.RuleParamValues.MinPercentage !== null && this.finalObjToPost.RuleParamValues.MinPercentage !== 'null' && this.finalObjToPost.RuleParamValues.MinPercentage !== '') && (this.finalObjToPost.RuleParamValues.MaxPercentage !== undefined && this.finalObjToPost.RuleParamValues.MaxPercentage !== 'undefined' && this.finalObjToPost.RuleParamValues.MaxPercentage !== null && this.finalObjToPost.RuleParamValues.MaxPercentage !== 'null' && this.finalObjToPost.RuleParamValues.MaxPercentage !== '')) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
              case constants.PersonalizationRule.Rule8:
              case constants.PersonalizationRule.Rule9:
                if (this.finalObjToPost.RuleParamValues.Path !== undefined && this.finalObjToPost.RuleParamValues.Path !== 'undefined' && this.finalObjToPost.RuleParamValues.Path !== null && this.finalObjToPost.RuleParamValues.Path !== 'null' && this.finalObjToPost.RuleParamValues.Path !== '' && this.finalObjToPost.RuleParamValues.Path.trim().length !== 0) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
              case constants.PersonalizationRule.Rule10:
              case constants.PersonalizationRule.Rule11:
              case constants.PersonalizationRule.Rule12:
              case constants.PersonalizationRule.Rule13:
                if (this.finalObjToPost.RuleParamValues.Outcome !== undefined && this.finalObjToPost.RuleParamValues.Outcome !== 'undefined' && this.finalObjToPost.RuleParamValues.Outcome !== null && this.finalObjToPost.RuleParamValues.Outcome !== 'null' && this.finalObjToPost.RuleParamValues.Outcome !== '') {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
              case constants.PersonalizationRule.Rule14:
                if ((this.finalObjToPost.RuleParamValues.UserProgress !== undefined && this.finalObjToPost.RuleParamValues.UserProgress !== 'undefined' && this.finalObjToPost.RuleParamValues.UserProgress !== null && this.finalObjToPost.RuleParamValues.UserProgress !== 'null' && this.finalObjToPost.RuleParamValues.UserProgress !== '')) {
                  isPresent = true
                } else {
                  isPresent = false
                }
                break
            }
            if (!isPresent) {
              this.getSelectedActionRuleObj = -1
            }
            return isPresent
          } else {
            this.getSelectedActionRuleObj = -1
            return false
          }
        } else {
          this.getSelectedActionRuleObj = -1
          return false
        }
      }
    },
    getSelectedRuleObj: {
      get: function () {
        return this.selectedRuleObj
      },
      set: function (newValue) {
        this.selectedRuleObj = newValue
        this.finalObjToPost.RuleParamValues = null
        this.showRuleUI = false
        setTimeout(() => {
          this.showRuleUI = true
        }, 5)
      }
    },
    getSelectedActionRuleObj: {
      get: function () {
        return this.selectedActionRuleObj
      },
      set: function (newValue) {
        this.selectedActionRuleObj = newValue
        this.$store.state.personalizationElementListToPost = []
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getRules: {
      get: function () {
        return this.elementRuleList
      }
    },
    getActions: {
      get: function () {
        return this.actionList
      }
    },
    getSelectedStepList: {
      get: function () {
        return this.$store.state.personalizationElementListToPost
      },
      set: function (newValue) {
        this.$store.state.personalizationElementListToPost = newValue
      }
    },
    getEditableRuleActionList: {
      get: function () {
        return this.editableRuleActionList
      }
    }
  },
  watch: {
    getSelectedStepList: function (newValue, oldValue) {
      console.log(this.selectedEditableRuleActionObj)
      if ((parseInt(this.selectedActionRuleObj) !== -1 && (this.selectedActionRuleObj.ActionName === constants.PersonalizationAction.Action1 || this.selectedActionRuleObj.ActionName === constants.PersonalizationAction.Action5)) || (this.selectedEditableRuleActionObj !== null && (this.selectedEditableRuleActionObj.ActionName === constants.PersonalizationAction.Action1 || this.selectedEditableRuleActionObj.ActionName === constants.PersonalizationAction.Action5))) {
        var objToReturn = {
          RuleType: this.selectedRuleObj.RuleName,
          RuleId: this.selectedRuleObj.RuleMasterId,
          ActionType: this.selectedActionRuleObj.ActionName,
          ActionMasterId: this.selectedActionRuleObj.ActionMasterId,
          ElementList: newValue.toString()
        }
        this.updateRuleActionValues(objToReturn)
      } else {
        console.log('Ignored.')
      }
    }
  }
}
</script>

<style scoped>
.background-color-light-grey {
  background-color: #fcfcfc;
}
.cursor-default {
  cursor: default !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.padding-left-15px {
  padding-left: 15px;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-17px {
  font-size: 17px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.text-color-orange {
  color: #f39c12;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}

.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.border-1px-solid-grey {
  border: 1px solid #aaa;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dadada;
}
.border-bottom-1px-solid-grey {
  border-bottom: 1px solid #dadada;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red{
  border: 1px solid red;
}
.padding-left-30px{
  padding-left:30px;
}
.font-size-12px{
  font-size:12px;
}
.padding-top-20px {
  padding-top: 20px;
}
.padding-bottom-20px {
  padding-bottom: 20px;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #34495e;
  cursor: pointer;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #34495e;
  cursor: pointer;
}
.align-center {
  margin: 0 auto !important;
}
.font-size-100px {
  font-size: 150px;
  color: #34495e;
}
.font-size-16px {
  font-size: 16px
}
.font-size-57px {
  font-size: 57px;
  color: #34495e;
}
.padding-top-1-Perc {
  padding-top: 1%;
}
.padding-top-3-Perc {
  padding-top: 3%;
}
.opacity-point-9 {
  opacity: 0.9;
}
.margin-top-5Perc {
  margin-top: 5%;
}
.margin-bottom-5Perc {
  margin-bottom: 5%;
}
.border-1px-solid-grey {
    border: 1px solid #aaa;
}
.margin-0-auto {
  margin: 0 auto;
}
</style>





// WEBPACK FOOTER //
// src/components/personalization_rule/AddRuleOverlay.vue